/**
 * Notificaciones in-app del solicitante (campana del header) · feed del CORE
 * (solicitudes de pago): autorizaciones por nivel, autorización completa,
 * rechazos, bajas y contabilización. Se fusiona en la campana con las
 * resoluciones de solicitudes de catálogo (módulo Administracion).
 */
import { axiosClient } from "@/shared/api/axios-client";

export type TipoNotificacion =
  | "AutorizacionNivel"
  | "AutorizacionCompleta"
  | "Rechazo"
  | "Baja"
  | "Contabilizacion";

export interface Notificacion {
  id: string;
  tipo: TipoNotificacion;
  solicitudId: string;
  numeroSolicitud: number;
  mensaje: string;
  creadaAt: string;
  /** null = aún no vista (alimenta el badge). */
  vistaAt: string | null;
}

export async function listarMisNotificaciones(): Promise<Notificacion[]> {
  const { data } = await axiosClient.get<Notificacion[]>("/api/notificaciones");
  return data;
}

export async function contarMisNotificacionesNoVistas(): Promise<number> {
  const { data } = await axiosClient.get<{ total: number }>(
    "/api/notificaciones/no-vistas/count"
  );
  return data.total;
}

export async function marcarMisNotificacionesVistas(): Promise<void> {
  await axiosClient.post("/api/notificaciones/marcar-vistas");
}

/** Oculta la notificación de MI campana (soft-delete · el registro persiste). */
export async function ocultarMiNotificacion(id: string): Promise<void> {
  await axiosClient.delete(`/api/notificaciones/${id}`);
}

// --- Avisos del canal Campana (módulo Notificaciones · hotspot 111) --------------------
// Los genera el motor de notificaciones con los flujos que diseña el administrador
// (/admin/notificaciones). Cada usuario ve SOLO los suyos (el backend filtra por dueño).

export interface AvisoApp {
  id: string;
  titulo: string;
  texto: string;
  /** Ruta interna ("/solicitudes/…") o URL absoluta http(s); null = sin enlace. */
  enlace: string | null;
  creadoAt: string;
  /** null = aún no visto (alimenta el badge). */
  vistoAt: string | null;
}

export interface MisAvisos {
  items: AvisoApp[];
  noVistos: number;
}

export async function listarMisAvisos(): Promise<AvisoApp[]> {
  const { data } = await axiosClient.get<MisAvisos>("/api/avisos", { params: { limite: 50 } });
  return data.items;
}

export async function contarMisAvisosNoVistos(): Promise<number> {
  const { data } = await axiosClient.get<{ total: number }>("/api/avisos/no-vistos/count");
  return data.total;
}

/** Marca como vistos TODOS mis avisos (sin ids = todos). */
export async function marcarMisAvisosVistos(): Promise<void> {
  await axiosClient.post("/api/avisos/marcar-vistos", {});
}

/** Oculta el aviso de MI campana (soft-delete · el registro persiste para la bitácora). */
export async function ocultarMiAviso(id: string): Promise<void> {
  await axiosClient.delete(`/api/avisos/${id}`);
}
